var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 98,
    viewBox: "0 0 62 98",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8223 61.0086C10.6938 62.8832 12.1077 64.5008 13.9609 64.6293C15.8248 64.7579 17.4422 63.3546 17.5814 61.4907C17.71 59.6268 16.3068 58.0093 14.4429 57.87C12.579 57.7415 10.9509 59.1447 10.8223 61.0086Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.525 66.2148C19.7997 65.1114 20.6566 63.526 20.7851 61.705C20.9136 59.8947 20.2924 58.1915 19.189 56.9167C18.0857 55.642 16.4896 54.785 14.6793 54.6565C12.869 54.5279 11.1658 55.1492 9.89105 56.2526C8.61632 57.3559 7.75925 58.952 7.64142 60.7623C7.52359 62.5834 8.14488 64.2866 9.24822 65.5613",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.197 54.6673V56.2741",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60938 61.2122H9.0339",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3601 61.2122H20.742",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56982 56.5848L10.6089 57.6132",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7961 57.6132L18.8245 56.5848",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7641 61.2123L11.7861 58.9199",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.233 61.0086C30.1044 62.8832 31.5183 64.5008 33.3715 64.6293C35.2354 64.7579 36.8531 63.3546 36.9923 61.4907C37.1209 59.6268 35.7177 58.0093 33.8538 57.87C31.9899 57.7415 30.3615 59.1447 30.233 61.0086Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9242 66.2147C39.1989 65.1114 40.056 63.526 40.1845 61.705C40.3131 59.8946 39.6918 58.1914 38.5884 56.9167C37.4851 55.642 35.889 54.785 34.0787 54.6565C32.2684 54.5279 30.5652 55.1492 29.2905 56.2525C28.0157 57.3559 27.1587 58.952 27.0408 60.7623C26.923 62.5834 27.5443 64.2866 28.6476 65.5613",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6079 54.6673V56.2741",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0203 61.2122H28.445",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7708 61.2122H40.1526",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.979 56.5848L30.0073 57.6132",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2068 57.6132L38.2351 56.5848",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1747 61.2123L31.197 58.9199",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.589 1H25.8731C21.5668 1 18.075 4.33144 18.075 8.45557V15.7826H27.148V10.041C27.148 9.38752 27.7049 8.85192 28.3905 8.85192H35.589",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.901 85.9464H20.3889C9.67685 85.9464 1 77.2697 1 66.5577V35.1714C1 24.4594 9.67685 15.7827 20.3889 15.7827H27.416C38.1281 15.7827 46.8046 24.4594 46.8046 35.1714V66.5577",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5937 85.1531C60.7454 78.0579 55.9273 71.3726 48.8321 70.2209C41.7369 69.0692 35.0515 73.8872 33.8998 80.9824C32.7481 88.0776 37.5662 94.7629 44.6614 95.9146C51.7566 97.0663 58.442 92.2483 59.5937 85.1531Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0218 85.1967C52.0218 88.1853 49.6009 90.617 46.6015 90.617C43.6021 90.617 41.1812 88.1961 41.1812 85.1967C41.1812 81.4153 46.6015 73.7777 46.6015 73.7777C46.6015 73.7777 52.0218 81.801 52.0218 85.1967Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil);
export default __webpack_public_path__ + "static/media/oil.ec94c2449162b812f31278397d0c5001.svg";
export { ForwardRef as ReactComponent };